<template>
	<div>
		<AllProjectsList
			:only-mine = true
			:administrator-panel="true"
		/>
	</div>
</template>

<script>
	import AllProjectsList from "../all_projects/AllProjectsList";

	export default {
		name: "UserProjects",
		components: {AllProjectsList},
		data() {
			return {
				projects: []
			};
		}
	};
</script>

<style scoped>

</style>
